import React, { useState } from "react";
import { EyeIcon, EyeSlashIcon, UserPlusIcon } from "@heroicons/react/24/outline";

export default function StaffCredentialsForm({
  jobData,
  username,
  setUsername,
  password,
  setPassword,
  loggingIn,
  loginError,
  onSubmit,
  onSwitchToWizard,
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="space-y-4 font-sans">
      {/* Job Info Banner */}
      <div className="bg-gradient-to-br from-slate-50 via-slate-100/50 to-primary-50/20 border border-slate-200/80 p-3.5 rounded-2xl text-left space-y-2 shadow-xs">
        <div>
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
            Job Site
          </p>
          <p className="text-xs font-bold text-slate-900">
            {jobData?.jobTitle || "QR Token Resolved"}
          </p>
          <p className="text-[10px] text-slate-500 font-semibold">
            Job ID: {jobData?.displayJobId || jobData?.jobId}
          </p>
        </div>
        <div>
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
            Address
          </p>
          <p className="text-xs text-slate-700 leading-relaxed font-medium">
            {[jobData?.streetAddress, jobData?.suburb, jobData?.city, jobData?.state]
              .filter(Boolean)
              .join(", ") || "Address not defined"}
          </p>
        </div>
      </div>

      <form onSubmit={onSubmit} className="space-y-3.5">
        <div>
          <label className="block text-[11px] font-bold text-slate-700 mb-1">
            Username / Email
          </label>
          <input
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-xs font-semibold text-slate-800 placeholder-slate-400 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10 transition-all shadow-xs"
            required
          />
        </div>

        <div className="relative">
          <label className="block text-[11px] font-bold text-slate-700 mb-1">
            Password
          </label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 pr-10 text-xs font-semibold text-slate-800 placeholder-slate-400 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10 transition-all shadow-xs"
              required
            />
            <button
              type="button"
              className="absolute top-2.5 right-3 text-slate-400 hover:text-slate-600 transition-colors cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <EyeSlashIcon className="h-4 w-4" />
              ) : (
                <EyeIcon className="h-4 w-4" />
              )}
            </button>
          </div>
        </div>

        {loginError && (
          <div className="p-2.5 rounded-xl border border-red-200 bg-red-50 text-center text-xs font-bold text-red-600">
            {loginError}
          </div>
        )}

        <button
          type="submit"
          disabled={loggingIn}
          className="w-full py-3 text-xs font-bold text-white bg-primary-600 hover:bg-primary-500 active:scale-[0.98] rounded-xl shadow-md hover:shadow-lg transition-all disabled:opacity-50 flex items-center justify-center space-x-2 cursor-pointer"
        >
          {loggingIn ? (
            <>
              <div className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white/30 border-t-white" />
              <span>Verifying credentials...</span>
            </>
          ) : (
            <span>Sign In &amp; Check In</span>
          )}
        </button>
      </form>

      <div className="pt-2 text-center border-t border-slate-100">
        <button
          type="button"
          onClick={onSwitchToWizard}
          className="inline-flex items-center gap-1.5 text-[11px] font-bold text-slate-500 hover:text-primary-600 transition-colors cursor-pointer"
        >
          <UserPlusIcon className="w-3.5 h-3.5 text-primary-600" />
          <span>Switch to Quick Worker Check-In</span>
        </button>
      </div>
    </div>
  );
}
